
import { showError } from '~/utils'
import stripeCountry from '~/mixins/stripe-country'

const SocialHead = () => import('~/components/SocialHead/index.vue')
const DowngradeCreatorTierModal = () => import('~/components/Modal/DowngradeCreatorTier/index.vue')

const BoostLandingNew = () => import('~/containers/Pricing/BoostLandingNew.vue')
export default {
  components: {
    SocialHead,
    DowngradeCreatorTierModal,
    BoostLandingNew,
  },
  mixins: [stripeCountry],
  data() {
    return {
      showDowngradeTier: {
        visibility: false,
        package: 'FREE',
      },
      showUnverified: false,
      isMounted: false,
      boostComponent: 0,
    }
  },
  head() {
    return {
      title: 'Boost - Gank',
      link: [
        {
          rel: 'canonical',
          href: 'https://ganknow.com/boost',
        },
      ],
    }
  },
  watch: {
    locale() {
      this.boostComponent += 1
    },
  },
  mounted() {
    this.$nextTick(async () => {
      try {
        const paymentCheck = await this.checkPayment()
        if (paymentCheck) {
          const {
            data: { data },
          } = await this.$axios.get('/users/me')
          this.$auth.setUser(data)
          this.$message.success('You have successfully upgraded your account!')
          this.$gtm.push({ event: 'boost_success' })
          this.$router.push('/manage/account')
        }
      } catch (error) {
        showError(error)
      }
      this.isMounted = true
    })
  },
  methods: {
    onDowngrade(value) {
      this.showDowngradeTier = {
        visibility: true,
        package: value,
      }
    },
    onGetStarted() {
      this.$gtm.push({ event: 'signup_boost' })
      this.$router.push('/signup')
    },
  },
}
